import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useLms } from '../../context/LmsContext';
import { Card, DataTable, PageHeader, ProgressBar, StatusBadge } from '../../components/ui';
import {
  assignmentGrade,
  byId,
  derivedAssignmentStatus,
  getAssignmentProgress,
  getAssignmentsForProgramAssignment,
  getProgramCourses,
  getProgramProgress,
  programGrade
} from '../../utils/lmsSelectors';

export default function LearnerProgram() {
  const { programAssignmentId } = useParams();
  const { data, currentUser } = useLms();
  const programAssignment = (data.programAssignments || []).find((item) => item.id === programAssignmentId && item.assignedToUserId === currentUser.id);
  if (!programAssignment) return <Card>Program assignment not found or access removed.</Card>;
  const program = byId(data.programs || [], programAssignment.programId);
  const progress = getProgramProgress(data, programAssignment);
  const grade = programGrade(data, programAssignment);
  const courseAssignments = getAssignmentsForProgramAssignment(data, programAssignment);
  const programCourses = getProgramCourses(data, programAssignment.programId);
  const rows = programCourses.map(({ course, sortOrder }) => {
    const assignment = courseAssignments.find((item) => item.courseId === course.id);
    const courseProgress = assignment ? getAssignmentProgress(data, assignment) : { percent: 0 };
    return {
      id: course.id,
      order: sortOrder,
      course: course.title,
      category: course.category,
      status: assignment ? derivedAssignmentStatus(data, assignment) : 'not_started',
      progress: courseProgress.percent,
      grade: assignment ? assignmentGrade(data, assignment) : null,
      assignmentId: assignment?.id || ''
    };
  });

  return (
    <>
      <PageHeader title={program?.title || 'Program'} eyebrow="My program" description={program?.description} />
      <div className="grid four">
        <Card><span className="muted">Status</span><h2><StatusBadge status={progress.status} /></h2></Card>
        <Card><span className="muted">Progress</span><ProgressBar value={progress.percent} /></Card>
        <Card><span className="muted">Due date</span><h2>{programAssignment.dueDate || 'No due date'}</h2></Card>
        <Card><span className="muted">Program grade</span><h2>{grade === null ? '—' : `${grade}%`}</h2></Card>
      </div>
      <Card>
        <h2>Courses in this program</h2>
        <DataTable
          rows={rows}
          columns={[
            { key: 'order', label: '#' },
            { key: 'course', label: 'Course', render: (row) => row.assignmentId ? <Link className="text-link strong-link" to={`/learner/course/${row.assignmentId}`}>{row.course}</Link> : row.course },
            { key: 'category', label: 'Category' },
            { key: 'status', label: 'Status', render: (row) => <StatusBadge status={row.status} /> },
            { key: 'progress', label: 'Progress', render: (row) => <ProgressBar value={row.progress} /> },
            { key: 'grade', label: 'Grade', render: (row) => row.grade === null ? '—' : `${row.grade}%` },
            { key: 'action', label: 'Action', render: (row) => row.assignmentId ? <Link className="button button-secondary" to={`/learner/course/${row.assignmentId}`}>Open course</Link> : 'Not assigned' }
          ]}
        />
      </Card>
    </>
  );
}
